import { gql } from '@apollo/client'

export const GET_HOMEPAGE_SETTINGS = gql`
  query GET_HOMEPAGE_SETTINGS {
    findFirstShopSetting {
      id
      homepage_content_blocks {
        id
        type
        style
        arrangement
        main_image {
          id
          src
        }
        gallery_images {
          id
          src
        }
        content_block_profiles {
          id
          name
          description
          language
        }
        config
        grid_product_containers {
          id
        }
        categories {
          id
          image {
            id
            src
          }
          banners {
            id
            src
          }
          category_profiles {
            id
            name
            language
          }
        }
      }
    }
  }
`

export const UPDATE_SHOP_SETTING_CONTENT_BLOCKS = gql`
  mutation UPDATE_SHOP_SETTING_CONTENT_BLOCKS(
    $where: ShopSettingWhereUniqueInput!
    $data: ShopSettingUpdateInput!
  ) {
    updateOneShopSetting(where: $where, data: $data) {
      id
      homepage_content_blocks {
        id
        type
        style
        arrangement
        content_block_profiles {
          id
          name
          language
        }
        config
        grid_product_containers {
          id
        }
        categories {
          id
          image {
            id
            src
          }
          banners {
            id
            src
          }
          category_profiles {
            id
            name
            language
          }
        }
      }
    }
  }
`

